/* EuroSpeed carousel engine (2026-09-22, widescreen + rebuild support 2026-10-08).
   Powers every "row of cars" strip on the site: infinite loop (cloned sets, invisible re-seat),
   constant slow crawl, desktop edge-hover glide with a centre dead zone, native swipe + snap on touch,
   arrows, reduced-motion respected. Same behaviour as the homepage Shop-by-Vehicle section, packaged
   so collection heroes and pages can reuse it.
   Markup: <div class="es-crs" data-es-carousel [data-drift="0.33"]>
             <div class="es-crs-arrow es-crs-prev" data-dir="-1">‹</div>
             <div class="es-crs-track"> <a class="es-crs-card" …>…</a> × N </div>
             <div class="es-crs-arrow es-crs-next" data-dir="1">›</div>
           </div>

   2026-10-08 (Jeff, widescreen monitor: carousels looked clipped). Two real engine bugs:
   1. es-vehicle-aware-hero.js replaces the cards with ones built from the live product grid and calls
      window.esCarouselInit() again, but init() returned early (root.__esCrs already set), so the new
      cards never got their loop clones and sat left-aligned with a dead area on the right.
      Calling esCarouselInit() now REBUILDS an already-running carousel from whatever cards are in the
      track (it also initialises a carousel that started empty).
   2. The loop only works if ONE set of cards is at least as wide as the viewport. With 6 cards on a
      2560px screen one set was ~1900px, so the wrap showed a gap. The set is now repeated until it
      covers the screen. A track with fewer than 4 cards that already fits is centred and static
      instead of repeating the same card across the screen. */
(function(){
  var CSS = ''
  + '.es-crs{position:relative;}'
  + '.es-crs-track{display:flex;gap:16px;overflow-x:auto;scroll-snap-type:x mandatory;padding:6px 20px 14px;-webkit-overflow-scrolling:touch;scrollbar-width:none;}'
  + '.es-crs-track::-webkit-scrollbar{display:none;}'
  + '.es-crs-track.is-loop{scroll-snap-type:none;scroll-behavior:auto;}'
  + '.es-crs-track.is-touch{scroll-snap-type:none;scroll-behavior:auto;}'
  + '.es-crs-track.is-touch.is-snap{scroll-snap-type:x mandatory;}'
  + '.es-crs-card{flex:0 0 300px;scroll-snap-align:center;position:relative;display:block;border-radius:16px;overflow:hidden;text-decoration:none;background:#11141b;border:1px solid rgba(255,255,255,.06);box-shadow:0 8px 26px rgba(0,0,0,.4);transition:transform .25s ease,box-shadow .25s ease,border-color .25s ease;}'
  + '.es-crs-card:hover{transform:translateY(-6px);box-shadow:0 14px 34px rgba(16,168,238,.28);border-color:rgba(16,168,238,.5);}'
  + '.es-crs-imgwrap{position:relative;display:block;padding-top:66.6%;}'
  + '.es-crs-imgwrap img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;}'
  + '.es-crs-scrim{position:absolute;inset:0;background:linear-gradient(180deg,rgba(8,10,15,0) 40%,rgba(8,10,15,.6) 66%,rgba(6,8,12,.95) 100%);}'
  + '.es-crs-txt{position:absolute;left:0;right:0;bottom:0;padding:14px 16px;}'
  + '.es-crs-label{display:block;color:#fff;font-size:17px;font-weight:800;line-height:1.2;text-shadow:0 1px 8px rgba(0,0,0,.6);}'
  + '.es-crs-cta{display:block;color:#5cc9f5;font-size:11px;font-weight:800;letter-spacing:.6px;text-transform:uppercase;margin-top:5px;}'
  + '.es-crs-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:46px;height:46px;border-radius:50%;border:1px solid rgba(255,255,255,.14);background:rgba(12,16,22,.72);backdrop-filter:blur(6px);color:#fff;font-size:22px;line-height:44px;text-align:center;cursor:pointer;transition:background .2s,border-color .2s;user-select:none;}'
  + '.es-crs-arrow:hover{background:#10a8ee;border-color:#10a8ee;}'
  + '.es-crs-prev{left:14px;}.es-crs-next{right:14px;}'
  + '.es-crs-edge{position:absolute;top:0;bottom:0;width:120px;pointer-events:none;z-index:2;opacity:0;transition:opacity .35s;}'
  + '.es-crs-edge.l{left:0;background:linear-gradient(90deg,rgba(8,9,13,.55),rgba(8,9,13,0));}'
  + '.es-crs-edge.r{right:0;background:linear-gradient(270deg,rgba(8,9,13,.55),rgba(8,9,13,0));}'
  + '.es-crs.is-scrolling .es-crs-edge{opacity:1;}'
  + '.es-crs[data-size="sm"] .es-crs-card{flex-basis:240px;border-radius:14px;}'
  + '.es-crs[data-size="sm"] .es-crs-label{font-size:15px;}'
  + '@media(max-width:760px){.es-crs-card{flex-basis:44vw;max-width:220px;border-radius:12px;}.es-crs-arrow{display:none;}.es-crs-track{gap:10px;padding:6px 14px 12px;}.es-crs-txt{padding:10px 11px;}.es-crs-label{font-size:13.5px;}.es-crs-cta{font-size:9.5px;margin-top:3px;letter-spacing:.4px;}.es-crs[data-size="sm"] .es-crs-card{flex-basis:40vw;max-width:200px;}}'
  + '@media(min-width:1700px){.es-crs-card{flex-basis:340px;}.es-crs[data-size="sm"] .es-crs-card{flex-basis:290px;}.es-crs-track{gap:20px;}}'
  + '@media(min-width:2200px){.es-crs-card{flex-basis:390px;}.es-crs[data-size="sm"] .es-crs-card{flex-basis:330px;}.es-crs-label{font-size:19px;}.es-crs-track{gap:24px;}}'
  + '.es-crs-track.is-static{justify-content:center;overflow-x:hidden;}'
  + '.es-crs.is-static .es-crs-arrow,.es-crs.is-static .es-crs-edge{display:none;}';

  /* The real copy of these rules lives in assets/es-ui.css, loaded in <head> so the first paint is
     already a carousel (see that file). This stays only as a fallback for a page that embeds a
     strip without the stylesheet; if es-ui.css is present it sets --es-crs-css and we do nothing. */
  function injectCss(){
    if(document.getElementById('es-crs-css')) return;
    try{ if(getComputedStyle(document.documentElement).getPropertyValue('--es-crs-css').trim()) return; }catch(_){}
    var st=document.createElement('style'); st.id='es-crs-css'; st.textContent=CSS; document.head.appendChild(st);
  }

  function init(root){
    var track=root.querySelector('.es-crs-track'); if(!track) return;
    if(root.__esCrsRebuild){ root.__esCrsRebuild(); return; }
    if(track.children.length<1) return;   // started empty: esCarouselInit() is called again once cards exist
    root.__esCrs=true;
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine=window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    if(!root.querySelector('.es-crs-edge')){ ['l','r'].forEach(function(s){ var e=document.createElement('div'); e.className='es-crs-edge '+s; e.setAttribute('aria-hidden','true'); root.insertBefore(e, track); }); }
    track.classList.add(fine?'is-loop':'is-touch');

    var setCards=[], N=0, setW=0, isStatic=false, curReps=0, GAP=16;
    function gapPx(){ var g=parseFloat(getComputedStyle(track).columnGap||getComputedStyle(track).gap); return isNaN(g)?16:g; }
    function viewW(){ return track.clientWidth || window.innerWidth; }
    function cardW(c){ return (c && c.offsetWidth) || 300; }
    function mark(c){ c.setAttribute('aria-hidden','true'); c.setAttribute('tabindex','-1'); c.classList.add('es-crs-clone'); return c; }
    function unmark(c){ c.removeAttribute('aria-hidden'); c.removeAttribute('tabindex'); c.classList.remove('es-crs-clone'); return c; }

    /* What the track should look like for the current screen: {stat:true} or {reps:k}. */
    function plan(uniq){
      GAP=gapPx();
      var step=cardW(uniq[0])+GAP, contentW=uniq.length*step;
      if(uniq.length<4 && contentW<=viewW()) return {stat:true, reps:0};
      return {stat:false, reps:Math.max(1, Math.ceil((viewW()*1.1)/contentW))};
    }

    function build(){
      /* Normalise whatever is in the track now (fresh cards from a rebuild, or a previously
         cloned track) down to one copy of each card. */
      var seen={}, uniq=[];
      Array.prototype.slice.call(track.children).forEach(function(c){
        var key=c.getAttribute('href')||c.outerHTML;
        if(seen[key]) return; seen[key]=1; uniq.push(unmark(c));
      });
      track.innerHTML='';
      uniq.forEach(function(c){ track.appendChild(c); });
      if(!uniq.length){ isStatic=true; return; }
      var p=plan(uniq);
      track.classList.toggle('is-static', p.stat); root.classList.toggle('is-static', p.stat);
      isStatic=p.stat; curReps=p.reps; setW=0; setCards=[];
      if(p.stat){ track.scrollLeft=0; return; }
      var frag=document.createDocumentFragment();
      for(var r=1;r<p.reps;r++) uniq.forEach(function(c){ frag.appendChild(mark(c.cloneNode(true))); });
      track.appendChild(frag);
      setCards=Array.prototype.slice.call(track.children); N=setCards.length;
      function add(where){ var f=document.createDocumentFragment(); setCards.forEach(function(c){ f.appendChild(mark(c.cloneNode(true))); }); where==='before'?track.insertBefore(f,track.firstChild):track.appendChild(f); }
      add('after'); add('before');
      seat();
    }
    function measure(){ if(isStatic||!track.children[2*N]) return; setW=track.children[2*N].offsetLeft-track.children[N].offsetLeft; }

    var DRIFT = reduce ? 0 : parseFloat(root.getAttribute('data-drift')||'0.33');
    var pos=0, paused=false, pauseTimer=null, visible=true, animating=false;
    function seat(){ measure(); pos=setW; track.scrollLeft=setW; }
    function wrapPos(){ if(isStatic||!setW) return; if(pos<setW*0.5){ pos+=setW; track.scrollLeft=Math.round(pos); } else if(pos>setW*1.5){ pos-=setW; track.scrollLeft=Math.round(pos); } }
    function pause(ms){ paused=true; clearTimeout(pauseTimer); if(ms) pauseTimer=setTimeout(function(){ paused=false; },ms); }

    var target=0, vx=0, down=false, MAX=11, DEAD=0.2;
    function fromPointer(e){ var r=track.getBoundingClientRect(); var x=(e.clientX-r.left)/r.width; var d = x<0.5-DEAD ? -((0.5-DEAD-x)/(0.5-DEAD)) : x>0.5+DEAD ? ((x-(0.5+DEAD))/(0.5-DEAD)) : 0; target=(d<0?-1:1)*Math.pow(Math.abs(d),1.6)*MAX; }

    function tick(){
      if(isStatic){ requestAnimationFrame(tick); return; }
      var v=(paused||!visible||animating)?0:DRIFT;
      if(fine && !reduce){ vx+=(target-vx)*(Math.abs(target)<Math.abs(vx)?0.16:0.08); if(down) vx=0; if(Math.abs(vx)<0.05) vx=0; if(!paused && !animating) v+=vx; }
      root.classList.toggle('is-scrolling', Math.abs(vx)>0.3);
      if(v!==0){ pos+=v; wrapPos(); var r=Math.round(pos); if(r!==track.scrollLeft) track.scrollLeft=r; }
      requestAnimationFrame(tick);
    }
    var settle=null;
    track.addEventListener('scroll',function(){ if(isStatic||animating) return; if(Math.abs(track.scrollLeft-Math.round(pos))>1){ pos=track.scrollLeft; pause(1800); } clearTimeout(settle); settle=setTimeout(wrapPos, fine?0:90); },{passive:true});
    if(fine && !reduce){
      track.addEventListener('mousemove',fromPointer); track.addEventListener('mouseenter',fromPointer);
      track.addEventListener('mouseleave',function(){ target=0; });
      track.addEventListener('mousedown',function(){ down=true; }); window.addEventListener('mouseup',function(){ down=false; });
      track.addEventListener('wheel',function(){ target=0; pause(1800); },{passive:true});
    } else {
      track.addEventListener('touchstart',function(){ track.classList.add('is-snap'); pause(0); },{passive:true});
      track.addEventListener('touchend',function(){ setTimeout(function(){ track.classList.remove('is-snap'); },600); pause(2200); },{passive:true});
      track.addEventListener('touchcancel',function(){ track.classList.remove('is-snap'); pause(2200); },{passive:true});
    }
    function cardStep(){ var c=track.querySelector('.es-crs-card'); return c?c.offsetWidth+gapPx():316; }
    function tweenBy(dx,ms){ if(isStatic) return; var from=pos, t0=performance.now(); animating=true; (function step(now){ var p=Math.min(1,(now-t0)/ms); var e=1-Math.pow(1-p,3); pos=from+dx*e; track.scrollLeft=Math.round(pos); if(p<1) requestAnimationFrame(step); else { animating=false; wrapPos(); pause(1200); } })(t0); }
    root.querySelectorAll('.es-crs-arrow').forEach(function(a){ a.addEventListener('click',function(){ tweenBy(parseInt(a.getAttribute('data-dir'),10)*cardStep()*1.4, 480); }); });
    if('IntersectionObserver' in window){ try{ new IntersectionObserver(function(en){ visible=en[0].isIntersecting; },{threshold:0.05}).observe(track); }catch(_){} }

    root.__esCrsRebuild=build;
    build();
    window.addEventListener('load',function(){ build(); });
    var rz=null;
    window.addEventListener('resize',function(){
      clearTimeout(rz);
      rz=setTimeout(function(){
        var uniq=Array.prototype.slice.call(track.querySelectorAll('.es-crs-card:not(.es-crs-clone)'));
        if(!uniq.length) return;
        var p=plan(uniq);
        if(p.stat!==isStatic || (!p.stat && p.reps!==curReps)){ build(); return; }
        if(isStatic) return;
        var frac=pos/(setW||1); measure(); pos=frac*setW; track.scrollLeft=Math.round(pos);
      },150);
    });
    requestAnimationFrame(tick);
  }
  function boot(){ injectCss(); document.querySelectorAll('.es-crs[data-es-carousel]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  window.esCarouselInit=boot;
})();
